import appEnv from './../../app.env.json';

export const environment = {
  production: false,
  PUBLIC_CONFIG: {
    ...appEnv.staging.PublicConfig,
  },
};
